import * as React from 'react';
import FullCellButton from './FullCellButton';
const ToDoKeyCell = ({ row }) => {
    const { key, known, onClickKey } = row.original;
    const className = known ? 'co-parse-ok' : 'co-parse-no-key';
    return (React.createElement(FullCellButton, { className: className, onClick: onClickKey, text: key }));
};
export default ToDoKeyCell;
